<template>
  <v-card width="100%" height="100%" >
    <v-toolbar color="secondary" dark class="title" flat>
        <v-icon left>fab fa-facebook</v-icon>
        <v-icon>fab fa-twitter</v-icon>
        <v-icon right>fab fa-instagram</v-icon>
        <span class="pl-2">
            Post to Social Media
        </span>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="subtitle-1">
          This app was originally built for <a href="https://themountcc.org" target="_blank" class="accent--text">The Mount</a>. Should the code need to be accessed it can be obtained by going to the <a href="https://gitlab.com/markrmessmore/mount-forms" target="_blank" class="accent--text">Gitlab Repository.</a> The firebase configuration information (in the appdata.js file) can be found either through the Google Drive -> Shared Drives -> Documentation -> Technology -> Mount Forms App folder or by having Angie or Mark venture into the <a href="https://console.firebase.google.com/u/0/" target="_blank" class="accent--text">Firebase Console</a> to obtain it from there.
        </v-col>
        <v-col cols="12" class="subtitle-1">
          This app was built using the following:
          <ul>
            <li>
              <a href="https://vuejs.org/" target="_blank" class="accent--text">Vue JS</a>  
            </li>
            <li>
              <a href="https://vuetifyjs.com/" target="_blank" class="accent--text">Vuetify</a>  
            </li>
            <li>
              <a href="https://firebase.google.com/" target="_blank" class="accent--text">Firebase (functions, hosting and firestore)</a>  
            </li>
            <li>
              <a href="https://github.com/axios/axios" target="_blank" class="accent--text">Axios (for some Firebase communication)</a>  
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {

  },
  data(){
    return {

    }
  }
}
</script>
